const FIVE_MINUTES_IN_SECONDS = 300;

export { FIVE_MINUTES_IN_SECONDS };
